'use client'

import { useEffect } from 'react'
import { tracking } from '@/tracking'

/** Kissmetrics: `Viewed {categoryName} landing page` (matches old dynamic category events). */
export function CategoryLandingViewTracker({
  categoryName,
  page,
}: {
  categoryName: string
  page: number
}) {
  useEffect(() => {
    if (!categoryName.trim() || page !== 1) return
    tracking.track(
      'Viewed category landing page',
      { categoryName: categoryName.trim() },
      { eventId: `category-landing:${categoryName.trim()}` }
    )
  }, [categoryName, page])

  return null
}
